import React from 'react';
import { FileCheckIcon, CheckCircleIcon } from 'lucide-react';
export const HeroSection = () => {
  return <section className="w-full bg-gradient-to-b from-white to-gray-50 py-16 md:py-24" data-id="element-165">
      <div className="container mx-auto px-4" data-id="element-166">
        <div className="flex flex-col md:flex-row items-center" data-id="element-167">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-168">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-169">
              Schluss mit dem Beleg-Chaos
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-170">
              TaxTidy ist dein smarter Buchhaltungsassistent, der Belege
              automatisch sammelt, sortiert und den passenden Transaktionen
              zuordnet – damit du dich auf dein Geschäft konzentrieren kannst.
            </p>
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 mb-8" data-id="element-171">
              <button className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition font-medium" data-id="element-172">
                Jetzt starten
              </button>
              <button className="border border-gray-300 text-gray-700 px-6 py-3 rounded-md hover:bg-gray-50 transition font-medium" data-id="element-173">
                Demo ansehen
              </button>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4" data-id="element-174">
              <div className="flex items-center" data-id="element-175">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-176" />
                <span className="text-gray-600" data-id="element-177">DSGVO-konform</span>
              </div>
              <div className="flex items-center" data-id="element-178">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-179" />
                <span className="text-gray-600" data-id="element-180">Keine Einarbeitung</span>
              </div>
              <div className="flex items-center" data-id="element-181">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-182" />
                <span className="text-gray-600" data-id="element-183">14 Tage kostenlos</span>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-184">
            <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 relative" data-id="element-185">
              <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="TaxTidy Anwendungsbeispiel" className="w-full rounded-lg shadow-md" data-id="element-186" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};